import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stripe': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M165 144.7l0.1 38.5h33.7v37.8h-33.7v63.2c0 26.2 28 18 33.7 15.7v33.8c-5.9 3.2-16.6 5.9-31.2 5.9-26.3 0-46.1-17-46.1-43.3l0.2-142.4zM254.1 196.3c10.4-19.1 31.1-15.2 37.1-13.1v40.8c-5.7-1.8-23.4-4.5-33.9 9.3v103.1h-44.3v-153.2h38.4zM346.4 124v36.2l-44.6 9.5v-36.2zM44.9 228.3c0 20 67.9 10.5 67.9 63.4 0 32-25.4 47.8-62.3 47.8-15.3 0-32-3-48.5-10.1v-40c14.9 8.1 33.9 14.2 48.6 14.2 9.9 0 17-2.7 17-10.9 0-21.2-67.5-13.2-67.5-62.4 0-31.4 24-50.2 60-50.2 14.7 0 29.4 2.3 44.1 8.1v41.8c-13.5-7.3-30.7-11.4-44.2-11.4-9.3 0.1-15.1 2.8-15.1 9.7zM640 261.6c0 4.3-0.4 13.6-0.6 15.9h-86.9c2 20.8 17.2 26.9 34.5 26.9 17.6 0 31.5-3.7 43.6-9.8v33.4c-12.1 6.7-28 11.5-49.2 11.5-43.2 0-73.5-24.7-73.5-78.2 0-45.2 25.7-81.1 67.9-81.1s64.2 35.9 64.2 81.4zM552.1 244.8h45.9c0-20-11.6-28.4-22.5-28.4-11.1 0-23.4 8.4-23.4 28.4zM439.2 180.2c31.2 0 60.6 28.1 60.5 79.7 0 56.4-29 79.6-60.8 79.6-15.5 0-25-6.5-31.4-11.2l-0.1 50.2-44.4 9.4v-204.8h39.1l2.3 11c6.2-5.7 17.4-13.9 34.8-13.9zM428.6 302.7c16.5 0 27.5-17.9 27.4-41.8 0-23.2-11.2-41.4-27.4-41.4-10.2 0-16.6 3.7-21.2 8.8l0.3 66c4.3 4.6 10.5 8.4 20.9 8.4zM301.9 336.4v-153.2h44.6v153.2h-44.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stripe.js
// module id = 1041
// module chunks = 0